export * from './ITooltip';
